import { SectionCard } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";
import { useInView } from "react-intersection-observer";
import { Link } from "wouter";

import { sendSelectTeaser, sendViewTeaser } from "../../common/tracking";
import type { ContentfulLargeTeaser } from "../../common/types/cmsTypes";
import { isExternalLink } from "../../common/utils";
import { getModuleVisibility } from "../../common/utils/segmentUtils";
import segmentStore from "../../stores/cms/segmentStore";
import FullWidthBackground from "../FullWidthBackground";

type LargeTeaserProps = {
   content: ContentfulLargeTeaser;
};

const LargeTeaser = ({ content }: LargeTeaserProps) => {
   const trackImpression = (isVisible: boolean) => {
      if (isVisible) {
         sendViewTeaser(title, contentType);
      }
   };

   const { ref: viewRef } = useInView({
      triggerOnce: true,
      onChange: trackImpression
   });

   const isVisible = getModuleVisibility(content, segmentStore.currentCustomerProperties);

   if (!isVisible) {
      return null;
   }
   const title = content.fields.title;
   const description = content.fields.description;
   const image = content.fields.image;
   const primaryButtonText = content.fields.buttonText;
   const primaryButtonLink = content.fields.buttonLink ?? "";
   const secondaryButtonText = content.fields.buttonText2;
   const secondaryButtonLink = content.fields.buttonLink2 ?? "";
   const themeBackground = content.fields.background;
   const imagePosition = content.fields.imagePosition;
   const contentType = content.sys.contentType.sys.id;

   const LinkComponent = isExternalLink(primaryButtonLink) || isExternalLink(secondaryButtonLink) ? "a" : Link;

   return (
      <div ref={viewRef} className="relative">
         {themeBackground && <FullWidthBackground color="bg-infoBoxBackground" />}

         <div className="relative py-8 lg:py-10">
            <SectionCard
               title={title}
               description={description}
               image={image?.fields.file?.url}
               imageAlt={image?.fields.title}
               primaryCtaLabel={primaryButtonText}
               primaryCtaHref={primaryButtonLink}
               secondaryCtaLabel={secondaryButtonText}
               secondaryCtaHref={secondaryButtonLink}
               linkComponent={LinkComponent}
               backgroundColor="transparent"
               isImageFlipped={imagePosition === "Right"}
               className="[&_strong]:font-semibold"
               onPrimaryCtaClick={() => sendSelectTeaser(title, contentType, undefined, `/${primaryButtonLink}`)}
               onSecondaryCtaClick={() => sendSelectTeaser(title, contentType, undefined, `/${secondaryButtonLink}`)}
            />
         </div>
      </div>
   );
};

export default observer(LargeTeaser);
